import { useSelector } from 'react-redux';
import { getRawEditorState } from '@/store/raweditor/actions';
import { useGetCampaignInfo } from './useGetCampaignInfo';

export const useGetContentTemplateName = () => {
    const { template } = useGetCampaignInfo();
    const { templateName } = useSelector(getRawEditorState);

    return template ?? templateName;
};
